import styles from "./PastOrder.module.css";
import { useTranslation } from "react-i18next";
import { czk_eur_rate } from "../../../constants/prices";
import { formatCurrencyFromCzk } from "../../../utils/prices";

type PastOrderSummaryProps = {
    visiblePrice: number;
    transport: number;
    selectedCurrency: string;
};

const PastOrderSummary = ({
    visiblePrice,
    transport,
    selectedCurrency,
}: PastOrderSummaryProps) => {
    const { t } = useTranslation();

    return (
        <div className={styles.ProductFooter}>
            <div className={styles.PriceSummary}>
                <div className={styles.PriceSummaryNoDph}>
                    <p>{t("cart.summary_section.price_without_dph")}</p>
                    <p>
                        {t("cart.summary_section.no_dph_short")}{" "}
                        {formatCurrencyFromCzk(visiblePrice, czk_eur_rate, selectedCurrency)}
                    </p>
                </div>
                <div className={styles.DeliverySummary}>
                    <p>
                        {t("cart.summary_section.delivery")}:{" "}
                        <span>{t("cart.summary_section.town_delivery")}</span>
                    </p>
                    <p>
                        {t("cart.summary_section.no_dph_short")}{" "}
                        {formatCurrencyFromCzk(transport, czk_eur_rate, selectedCurrency)}
                    </p>
                </div>
            </div>

            <div className={styles.CompleteSummary}>
                <p>{t("cart.summary_section.total")}</p>
                <p>
                    {t("cart.summary_section.no_dph_short")}{" "}
                    {formatCurrencyFromCzk(
                        transport + visiblePrice,
                        czk_eur_rate,
                        selectedCurrency
                    )}
                </p>
            </div>
        </div>
    );
};

export default PastOrderSummary;
